



























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import NewsModel from '@views/a-model/news-model';
import DefaultModel from '@views/a-model/default-model';
import EnumNewsType from '../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';
import iMobileDeviceUser from '../a-model/interfaces/iMobileDeviceUser';
import { EnumRoleType } from '../a-model/enum/EnumRoleType';
import iKpi from '../a-model/interfaces/iKpi';
import iKpiUser from '../a-model/interfaces/iKpiUser';

@Component({
  name: 'kpi-user',
  components: {},
})
export default class KpiUserComponent extends Vue {
  currentRolleId: String = null;
  currentUserId: String = null;
  userId: String = null;
  pageSize = 10;
  currentPage = 1;
  totalItems = 12;

  kpi: iKpi = null;

  modalWindowTitle = '';
  modalWindowShow = false;
  toDate: Date = new Date();
  fromDate: Date = new Date();
  targets = '';

  terminaleCode = '';

  mobileUsers: ListViewItem<DefaultModel>[] = [];

  innerItems: iKpiUser[] = [];
  reward = '';
  quantity = '';

  created() {
    document.title = this.$route.meta.title;
    this.getKpi();
  }

  onChangeDate() {}

  onAddKpi() {
    if (this.mobileUsers.filter((el) => el.Selected == true).length > 0) {
      this.$api.KpiService.AddUserToKpiEvent.once((response) => {
        if (!response.IsSuccess) {
          return;
        }
        this.getItems({ Take: this.pageSize, Skip: 0 });
      });

      this.$api.KpiService.AddUserToKpi({ UserId: this.mobileUsers.filter((el) => el.Selected == true)[0].Value.id, KpiId: this.kpi.id });
      this.closeModalWindow();
    } else {
      this.$dialog.alert(this.$locale.getTranslate('selectMobileUser'));
    }
  }

  onShowWindowAddUser() {
    this.modalWindowShow = true;
  }

  goKpi() {
    this.$router.push({ path: '/kpi' });
  }

  getMobileUsers(search: string): Boolean {
    this.$api.KpiService.GetUserForAddingEvent.once((response) => {
      if (!response.IsSuccess) {
        return false;
      }
      this.mobileUsers = [];
      response.Value.forEach((element) => {
        this.mobileUsers.push(new ListViewItem(new DefaultModel(element.UserId, element.FullName.toString()), false, false));
      });
    });
    this.$api.KpiService.GetUserForAdding({ ScheduleId: parseInt(this.kpi.id.toString()), Search: search });
    return true;
  }

  changeAutocomlite(serchTermit: string) {
    this.getMobileUsers(serchTermit);
  }

  /**Получаем информацию о текущем KPI */
  getKpi() {
    this.$api.KpiService.GetSingleKpiEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }

      var item = response.Value;
      this.kpi = {
        id: item.Id,
        target: item.GoalDescription,
        fromDate: item.DateStart,
        toDate: item.DateEnd,
        reward: 0,
      };
      this.getItems({ Take: this.pageSize, Skip: 0 });
      this.getMobileUsers('');
    });
    this.$api.KpiService.GetSingleKpi(parseInt(this.$route.params.kpiId));
  }

  getItems({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.KpiService.GetPaginatedUserGoalProgressListEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.innerItems = [];
      this.totalItems = response.Value.Count;
      this.innerItems = response.Value.Items.map((item) => ({
        id: item.UserId,
        name: item.Name != null ? item.Name : '',
        quantity: item.Count,
      }));
    });
    this.$api.KpiService.GetPaginatedUserGoalProgressList({ Id: this.kpi.id, Skip: Skip, Take: this.pageSize });
  }

  closeModalWindow() {
    this.modalWindowShow = false;
  }

  isValid(): boolean {
    // if(this.fileZip==null && (!this.addingNews===undefined) &&!this.addingNews.folderName.startsWith("http")){
    //   this.zipAlert=true;
    // }

    // if(this.file==null){
    //   this.imageAlert=true;
    // }
    // else this.imageAlert=false
    // return ((this.$refs.validator as ControlValidatorGroupComponent).isValid() && !this.zipAlert && !this.imageAlert);
    return true;
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.getItems({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage,
    });
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case 'id':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case 'target':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.target > b.target ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.target < b.target ? 1 : -1;
          });
          break;
        }
      case 'reward':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.reward > b.reward ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.reward < b.reward ? 1 : -1;
          });
          break;
        }

      default:
        break;
    }
  }
  onChangeUser(userId: string) {
    this.$router.push({ path: `devices/${userId}` });
  }
  async onDeleteKpi(kipId: string) {
    var res = await this.$dialog.confirm(this.$locale.getTranslate('Dialog_reallyDelete')).then((res: boolean) => {
      if (res) {
        // this.$api.NewsService.DeleteEvent.once(response => {
        //   if (!response.IsSuccess) {
        //     return;
        //   }
        //   this.getNews({ Take: this.pageSize, Skip: this.currentPage });
        // });
        // this.$api.NewsService.Delete(parseInt(newsId));
      }
      if (res == false) {
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-kpi-user.vue